// extracted by mini-css-extract-plugin
export default {"loadingContainer":"d1ac66c0","card":"ea9ba90b"};